import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Item, ItemResponse } from '../interfaces/item.interface';
import {AuthService} from "./auth.service";

export const ItemService = {
    getItemsByInstitution: async (page: number = 0, size: number = 10, search: string = '', missingSellPrice: boolean = false): Promise<ItemResponse> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.ITEM.LIST_BY_INSTITUTION}/${institutionId}?page=${page}&size=${size}&search=${encodeURIComponent(search)}&missingSellPrice=${missingSellPrice}`);
        return response.data;
    },

    createItem: async (item: Item): Promise<void> => {
        await axios.post(ENDPOINTS.ITEM.BASE, item);
    },

    updateItem: async (id: string, item: Item): Promise<void> => {
        await axios.put(ENDPOINTS.ITEM.UPDATE(id), item);
    },

    deleteItem: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.ITEM.DELETE(id));
    }
};
